import { render, staticRenderFns } from "./EbookSection.vue?vue&type=template&id=c96fff98&scoped=true&"
import script from "./EbookSection.vue?vue&type=script&lang=js&"
export * from "./EbookSection.vue?vue&type=script&lang=js&"
import style0 from "./EbookSection.vue?vue&type=style&index=0&id=c96fff98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96fff98",
  null
  
)

export default component.exports